import {sourcePath} from "../../utils/path";
import {motion} from "framer-motion";

const Img=({src,className='',alt='',...rest})=>{
    return <img src={src.replace("./",sourcePath)} alt={alt} className={className.includes('pointer-events-')?className:className+' pointer-events-none'} {...rest}/>
}
export default Img

export const MotionImg =({src,alt='',...rest})=>{
    return <motion.img src={src.replace("./",sourcePath)} alt={alt} {...rest}/>
}